/** @type {Set<string>} */
const loadedScripts = new Set();

/**
 * Loads an external script once per URL (non-render-blocking).
 * @param {string} src
 * @param {{ id?: string }} [options] - e.g. id Zammad expects on its script tag (`zammad_form_script`)
 */
export function loadScript(src, options = {}) {
  const dedupeKey = options.id ? `${src}#id=${options.id}` : src;
  if (loadedScripts.has(dedupeKey)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    if (options.id) {
      el.id = options.id;
    }
    el.src = src;
    el.async = true;
    el.onload = () => {
      loadedScripts.add(dedupeKey);
      resolve();
    };
    el.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(el);
  });
}
